var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3281 2.10938H12.1927L11.8499 1.08148C11.6342 0.434637 11.0311 0 10.3493 0H7.65074C6.96888 0 6.36585 0.434637 6.14957 1.08148L5.80718 2.10938H2.67188C1.79951 2.10938 1.08984 2.81904 1.08984 3.69141V4.74609C1.08984 5.33348 1.61863 5.27344 2.18612 5.27344C7.05716 5.27344 11.4735 5.27344 16.3828 5.27344C16.6743 5.27344 16.9102 5.03757 16.9102 4.74609V3.69141C16.9102 2.81904 16.2005 2.10938 15.3281 2.10938ZM6.91921 2.10938L7.15018 1.41518C7.22229 1.19939 7.42363 1.05469 7.65074 1.05469H10.3493C10.5764 1.05469 10.7777 1.19939 10.8493 1.41518L11.0805 2.10938H6.91921Z",
    fill: "#004899"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.27344 6.39844L3.11427 16.5611C3.18894 17.3815 3.86616 18 4.68962 18H13.3105C14.1339 18 14.8111 17.3815 14.8863 16.5565L15.7267 6.39844H2.27344ZM6.3633 15.3633C6.3633 16.0584 5.30862 16.0613 5.30862 15.3633V7.98047C5.30862 7.28532 6.3633 7.28248 6.3633 7.98047V15.3633ZM9.52737 15.3633C9.52737 16.0584 8.47268 16.0613 8.47268 15.3633V7.98047C8.47268 7.28532 9.52737 7.28248 9.52737 7.98047V15.3633ZM12.6914 15.3633C12.6914 16.0584 11.6367 16.0613 11.6367 15.3633V7.98047C11.6367 7.68899 11.8726 7.45312 12.1641 7.45312C12.4556 7.45312 12.6914 7.68899 12.6914 7.98047V15.3633Z",
    fill: "#E53323"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/Delete.271c458696e731351f1cb9802e89534f.svg";
export { ForwardRef as ReactComponent };